import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-migrate-railway',
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './railway.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../migrate.shared.css', './railway.component.css'],
})
export class MigrateRailwayComponent {}
